import { Box, Button, Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

/**
 * Component for displaying a single NAT Gateway with status and action buttons
 *
 * @param {Object} props Component props
 * @param {string} props.name Name of the NAT gateway
 * @param {boolean} props.isReady Whether the gateway is available
 * @param {boolean} props.disabled Whether operations are disabled for this gateway
 * @param {Function} props.onDelete Function to call when delete button is clicked
 * @param {Function} props.onCreate Function to call when create button is clicked
 * @returns {JSX.Element} The NAT gateway card element
 */
const NatGatewayCard = ({ name, isReady, disabled, onDelete, onCreate }) => {
  return (
    <Grid size={{ xs: 12, md: 6, lg: 4, xl: 3 }}>
      <Paper sx={{ p: { xs: 3, sm: 4 } }}>
        <Grid container display="flex" alignItems="center" spacing={1} py="5px">
          <Grid size="grow">
            <Typography
              variant="h1"
              sx={{
                fontSize: "1.5rem",
                fontWeight: "bold",
                display: "inline-block",
              }}
            >
              {name}
            </Typography>
          </Grid>
          <Grid size="auto" justifyContent={"flex-end"} display="flex">
            {isReady ? (
              <Button variant="outlined" color="error" disabled={disabled} onClick={onDelete}>
                Delete
              </Button>
            ) : (
              <Button variant="outlined" color="inherit" disabled={disabled} onClick={onCreate}>
                Create
              </Button>
            )}
          </Grid>
        </Grid>
        <Grid>
          <Box display="flex" pt="10px">
            <Typography variant="h1" sx={{ fontSize: "1rem" }}>
              {isReady ? "AVAILABLE" : "UNAVAILABLE"}
            </Typography>
          </Box>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default NatGatewayCard;
